import React, { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';
import { HostSettingsCard } from './HostSettingsCard';
import { getConsent, reopenConsentBanner, onConsentChange } from '../utils/cookieConsent';

// Privacy-settings card that lets the user revisit their cookie / analytics
// consent decision. GDPR requires consent to be as easy to withdraw as it
// is to grant — this re-opens the same banner used at first launch.
export default function CookiePreferencesCard({ dataTestId = 'cookie-preferences-card' }) {
  const [consent, setConsent] = useState(() => getConsent());

  useEffect(() => onConsentChange(() => setConsent(getConsent())), []);

  const statusLabel = !consent.decided
    ? 'No choice yet'
    : consent.categories.analytics
      ? 'Analytics enabled'
      : 'Analytics disabled';

  const statusColor = consent.categories.analytics ? 'var(--status-success-text)' : 'var(--text-2)';

  return (
    <HostSettingsCard data-testid={dataTestId}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <Cookie size={22} color="var(--text)" />
        <p style={{ fontFamily: "'Inria Serif', serif", fontSize: 18, color: 'var(--text)', margin: 0 }}>
          Cookie preferences
        </p>
      </div>
      <p style={{ fontSize: 13, color: 'var(--text-2)', margin: '0 0 8px', lineHeight: 1.45 }}>
        Strictly-necessary cookies (sign-in, security) are always on. Analytics
        cookies are optional and only used to measure how invites are shared.
      </p>
      <p
        data-testid="cookie-preferences-status"
        style={{ fontSize: 12.5, fontWeight: 700, color: statusColor, margin: '0 0 12px' }}
      >
        Current setting: {statusLabel}
      </p>
      <button
        type="button"
        onClick={reopenConsentBanner}
        data-testid="cookie-preferences-open-button"
        style={{
          background: 'var(--solid-cta-bg)',
          color: 'var(--solid-cta-text)',
          border: 'none',
          borderRadius: 999,
          padding: '9px 16px',
          fontSize: 12.5,
          fontWeight: 700,
          cursor: 'pointer',
          letterSpacing: 0.2,
          fontFamily: 'inherit',
        }}
      >
        Change cookie preferences
      </button>
    </HostSettingsCard>
  );
}
